<template>
	<div>
		<!-- --- 약관 선택 --- -->
		<!-- <p v-if="where === 'reserve_day'" class="selectedRes my-5"> -->
		<!-- 예약확인 알림톡 발송을 위한 개인정보 활용에 동의해주세요. <span class="required-red-dot">*</span> -->
		<!-- </p> -->
		<!-- <p v-else class="selectedRes my-5">알림톡 발송을 위한 개인정보 활용에 동의해주세요. <span class="required-red-dot">*</span></p> -->
		<!-- <check-box :check="check1" @click="agreeAll"></check-box> -->
		<!-- <v-divider class="startDivider mt-3 " /> -->
		<!-- <v-layout align-baseline>
			<check-box :check="check2" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="startshowTerm" @click="detail(1)">보기</span>
		</v-layout> -->
		<!-- <v-divider class="startDivider mt-3" /> -->
		<v-layout align-baseline>
			<check-box :check="check3" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="startshowTerm" @click="detail(2)">보기</span>
		</v-layout>
		<!-- <v-divider class="startDivider mt-3" /> -->
		<!-- <v-layout align-baseline>
			<check-box :check="check4" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="startshowTerm" @click="detail(3)">보기</span>
		</v-layout> -->
		<!-- <v-divider class="startDivider mt-3" />
		<v-layout align-baseline>
			<check-box :check="check5" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="startshowTerm" @click="detail(4)">보기</span>
		</v-layout> -->
		<!-- <v-divider class="startDivider mt-3" /> -->
		<v-layout align-baseline v-if="$route.params.code === '1rbo2fsusgv'">
			<check-box :check="check6" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="startshowTerm" @click="detail(4)">보기</span>
		</v-layout>
		<!-- <v-layout align-baseline>
			<check-box :check="check4" @click="disagree"></check-box><v-spacer></v-spacer>
			<span class="startshowTerm" @click="detail(3)">보기</span>
		</v-layout> -->
		<agree-dialog :setdialog="agreeDialog" />
	</div>
</template>

<script>
import checkBox from './checkBox.vue'
import agreeDialog from './dialog/agreeDialog.vue'

export default {
	components: { checkBox, agreeDialog },
	props: {
		urlInfo: String,
		changeBtn: Function,
	},
	data() {
		return {
			agreeDialog: {
				dialog: false,
				title: '',
				content: '',
			},
		}
	},
	created() {
		this.$store.state.check1.class = 'startTerm'
		this.$store.state.check2.class = 'startTermsmall'
		this.$store.state.check3.class = 'startTermsmall'
		this.$store.state.check4.class = 'startTermsmall'
		this.$store.state.check5.class = 'startTermsmall'
		this.$store.state.check6.class = 'startTermsmall'
		if (this.$route.params.code === 'rib4u2000gb') {
			this.$store.state.check3.label = '개인정보 처리업무 위탁에 대한 안내'
		}
		this.$store.state.check1.color = this.$store.state.PointColor7
		this.$store.state.check2.color = this.$store.state.PointColor7
		this.$store.state.check3.color = this.$store.state.PointColor7
		this.$store.state.check4.color = this.$store.state.PointColor7
		this.$store.state.check5.color = this.$store.state.PointColor7
		this.$store.state.check6.color = this.$store.state.PointColor7
	},
	computed: {
		where() {
			return this.urlInfo.split('/')[1]
		},
		check1: {
			get() {
				return this.$store.state.check1
			},
			set(value) {
				this.$store.commit('check1', value)
			},
		},
		check2: {
			get() {
				return this.$store.state.check2
			},
			set(value) {
				this.$store.commit('check2', value)
			},
		},
		check3: {
			get() {
				return this.$store.state.check3
			},
			set(value) {
				this.$store.commit('check3', value)
			},
		},
		check4: {
			get() {
				return this.$store.state.check4
			},
			set(value) {
				this.$store.commit('check4', value)
			},
		},
		check5: {
			get() {
				return this.$store.state.check5
			},
			set(value) {
				this.$store.commit('check5', value)
			},
		},
		check6: {
			get() {
				return this.$store.state.check6
			},
			set(value) {
				this.$store.commit('check6', value)
			},
		},
	},
	methods: {
		detail(num) {
			this.terms(num - 1)
		},
		terms(num) {
			console.log(this.$store.state.termIdList, num)
			const data = {
				stat: 1,
				id: this.$store.state.termIdList[num],
			}
			this.$store.dispatch('terms', data).then(res => {
				this.agreeDialog.dialog = true
				if (res.data.terms.length > 0) {
					this.agreeDialog.title = res.data.terms[0].title
					this.agreeDialog.content = res.data.terms[0].content
				}
			})
		},
		agreeAll() {
			//전체동의
			if (this.check1.value) {
				// this.check2.value = true
				this.check3.value = true
				// this.check4.value = true
				this.check5.value = true
				// this.check6.value = true
			} else {
				// this.check2.value = false
				this.check3.value = false
				// this.check4.value = false
				this.check5.value = false
				// this.check6.value = false
			}
			// this.check4.value = false
			this.changeBtn()
		},
		checkAgree() {
			//약관 동의
			if (this.check3.value && this.check5.value) {
				this.check1.value = true
			} else {
				this.check1.value = false
			}
			this.changeBtn()
		},
		disagree() {
			//동의 없이 시작
			if (this.check4.value) {
				this.check1.value = false
				this.check2.value = false
				this.check3.value = false
			}
			this.changeBtn()
		},
	},
}
</script>

<style lang="scss">
.startTerm {
	margin-top: 5px;
	.v-icon {
		font-size: 25px;
	}
	.v-label {
		font-size: 14px;
		font-weight: 400;
		margin-left: 5px;
	}
}
.startTermsmall {
	margin-top: 5px;

	.v-label {
		font-size: 14px;
		font-weight: 300;
		color: #909090 !important;
		margin-left: 5px;
	}
}
.selectedRes {
	font-size: 13px;
	font-weight: bold;
	margin-bottom: 0px !important;
	span {
		color: #006b8f;
	}
}
.startshowTerm {
	cursor: pointer;
	font-size: 10px;
	color: #a2a2a2a0;
	text-decoration: underline;
	text-size-adjust: none;
	-webkit-text-size-adjust: none; /* 크롬, 사파리, 오페라 신버전 */
	-ms-text-size-adjust: none; /* IE */
	-moz-text-size-adjust: none; /* 파이어폭스 */
	-o-text-size-adjust: none; /* 오페라 구버전 */
}
.required-red-dot {
	font-size: 24px;
	color: #ff5252 !important;
}
</style>
